import matic from './matic-logo.png'
import usdc from './usdc-logo.png'
import wbtc from './wbtc-logo.png'
import weth from './weth-logo.png'
import swaap from './swaap-logo.png'
import dai from './dai-logo.png'

const coinMap = new Map<string, string>()
coinMap.set('matic', matic)
coinMap.set('usdc', usdc)
coinMap.set('wbtc', wbtc)
coinMap.set('weth', weth)
coinMap.set('swaap', swaap)
coinMap.set('dai', dai)

export function coinImage(coin: string) {
  return coinMap.get(coin.toLowerCase())
}

export function coinPublicImage(coin: string) {
  const image = `https://${getDomainName()}/assets/coins/${coin.toLowerCase()}-logo.png`
  return image
}

export function getDomainName() {
  return window.location.hostname
}
